export default "__VITE_ASSET__CwJ2bV7E__"